import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/pro-solid-svg-icons';
import { faEdit } from '@fortawesome/pro-regular-svg-icons';

import Comp, { getCompEditUrl } from 'components/comps/row';
import confirm from 'components/confirm';
import { deleteRequest } from 'helpers/api';
import { listItemPropTypes, reorderableListItem } from 'helpers/react_dnd/reorderable_list';

export class PropertyComp extends React.Component {
  static propTypes = {
    ...listItemPropTypes,
    propertyComp: PropTypes.shape({
      id: PropTypes.number.isRequired,
      path: PropTypes.string.isRequired,
      researchComp: PropTypes.shape({
        editMarketingCompPath: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
    onRemove: PropTypes.func.isRequired,
  }

  remove = async () => {
    try {
      await confirm('Are you sure you want to remove this comp from this project?', {
        buttonLabel: 'Remove',
        buttonStyle: 'danger',
        title: 'Remove Comp?'
      });

      await deleteRequest(this.props.propertyComp.path);
      this.props.onRemove(this.props.propertyComp);
    } catch (e) {
      return;
    }
  }

  render() {
    const { editMarketingCompPath } = this.props.propertyComp.researchComp;

    return this.props.connectDragPreview(this.props.connectDropTarget(
      <div>
        <Comp comp={this.props.propertyComp.researchComp} connectDragSource={this.props.connectDragSource}>
          <a className="clickable me-4" href={getCompEditUrl(editMarketingCompPath)} name="edit">
            <FontAwesomeIcon className="me-1" icon={faEdit} size="lg" />
            Edit
          </a>
          <span className="clickable text-danger" name="remove" onClick={this.remove}>
            <FontAwesomeIcon className="me-1" icon={faTrash} size="lg" />
            Remove
          </span>
        </Comp>
      </div>
    ));
  }
}

export default reorderableListItem(PropertyComp, 'PropertyComps', {
  beginDrag(props) {
    return {
      id: props.propertyComp.id,
      index: props.index,
    };
  }
});
